import { SignedOut, RedirectToSignIn } from "@clerk/clerk-react";

export default function Login() {

  return (
    <SignedOut>
      <RedirectToSignIn />
    </SignedOut>
  )
}